import TablePagination from '@mui/material/TablePagination';

import { ROTULOS_DA_PAGINACAO, TAMANHOS_DE_PAGINA, type BuscaPaginada } from './useBuscaPaginada';

/** O rodapé de página das tabelas de itens e de divergências: "1–25 de 397", itens por página e setas. */
export function PaginacaoDaTabela({
  total,
  busca,
}: {
  total: number;
  busca: Pick<BuscaPaginada, 'pagina' | 'definirPagina' | 'tamanho' | 'definirTamanho'>;
}): React.JSX.Element {
  return (
    <TablePagination
      component="div"
      count={total}
      page={busca.pagina}
      rowsPerPage={busca.tamanho}
      rowsPerPageOptions={TAMANHOS_DE_PAGINA}
      labelRowsPerPage="Itens por página"
      getItemAriaLabel={(tipo) => ROTULOS_DA_PAGINACAO[tipo]}
      labelDisplayedRows={({ from, to, count }) => `${String(from)}–${String(to)} de ${String(count)}`}
      onPageChange={(_evento, novaPagina) => {
        busca.definirPagina(novaPagina);
      }}
      onRowsPerPageChange={(evento) => {
        busca.definirTamanho(Number(evento.target.value));
        busca.definirPagina(0);
      }}
    />
  );
}
